// AjaxQ jQuery Plugin
// Copyright (c) 2012 Foliotek Inc.
// MIT License
// https://github.com/Foliotek/ajaxq

(function ($) {

    var queues = {};
    var reqs = {};
    var activeReqs = {};

    /**
     * Register an $.ajaxq function, which follows the $.ajax interface,
     * but allows a queue name which will force only one request per queue to fire.
     * @param qname     a queue name used as an identifier
     * @param opts      the classic $.ajax options argument
     * @returns {!jQuery.jqXHR}
     */
    $.ajaxq = function (qname, opts) {

        if (typeof opts === "undefined") {
            throw ("AjaxQ: queue name is not provided");
        } else if (typeof opts === "string") {
            opts = {url: opts};
        }
        if (!reqs[qname])
            reqs[qname] = {};

        var optsStr = JSON.stringify({url: opts.url, data: opts.data, type: opts.type});
        var queuedReq = reqs[qname][optsStr];
        if (!queuedReq) {
            // Will return a Deferred promise object extended with success/error/callback, so that this function matches the interface of $.ajax
            var deferred = $.Deferred();

            // Create a deep copy of the arguments, and enqueue this request.
            var clonedOptions = $.extend(true, {}, opts);
            enqueue(function () {
                // Send off the ajax request now that the item has been removed from the queue
                var jqXHR = $.ajax.apply(window, [clonedOptions]);

                // now it's time to fill in the missing fields and functions of the previously created
                // $.deferred object to match the jqXhr interface.
                for (let key in jqXHR)
                    if (jqXHR.hasOwnProperty(key) && !deferred.hasOwnProperty(key))
                        deferred[key] = jqXHR[key];

                // Notify the returned deferred object with the correct context when the jqXHR is done or fails
                // Note that 'always' will automatically be fired once one of these are called: http://api.jquery.com/category/deferred-object/.
                jqXHR.done(function () {
                    deferred.resolve.apply(this, arguments);
                }).fail(function () {
                    deferred.reject.apply(this, arguments);
                }).always(dequeue); // make sure to dequeue the next request AFTER the done and fail callbacks are fired
                return jqXHR;
            });
            // A hash made by the ajax call's setup is used to store the promise for future use.
            reqs[qname][optsStr] = deferred;
//			console.log("Request " + optsStr + " added to queue " + qname );
            return deferred;
        } else {
            console.warn("Multiple calls for configuration: " + optsStr + " prevented. Handler was given old promise.");
            var oldPromise = reqs[qname][optsStr];
            if (opts.success)
                oldPromise.done(opts.success);
            if (opts.error)
                oldPromise.fail(opts.error);
            return oldPromise;
        }

        /**
         * If there is no queue, create an empty one and instantly process this item.
         * Otherwise, just add this item onto it for later processing.
         * @param cb        a callback function initiating the underlying ajax call
         *                  and returning the jqXhr object to be stored and processed
         */
        function enqueue(cb) {
            if (!queues[qname]) {
                queues[qname] = [];
                activeReqs[qname] = cb();
            } else {
                queues[qname].push(cb);
            }
        }

        /**
         * Remove the next callback from the queue and fire it off.
         * If the queue was empty (this was the last item), delete it from memory
         * so the next one can be instantly processed.
         */
        function dequeue() {
            if (!queues[qname]) {
                return;
            }
            delete reqs[qname][optsStr];
            var nextCallback = queues[qname].shift();
            if (nextCallback) {
                activeReqs[qname] = nextCallback();
            } else {
                delete queues[qname];
                delete activeReqs[qname];
            }
            //console.log("Request " + optsStr + " removed from queue " + qname );
        }
    };

    // Register a $.postq and $.getq method to provide shortcuts for $.get and $.post
    // Copied from jQuery source to make sure the functions share the same defaults as $.get and $.post.
    $.each(["getq", "postq"], function (i, method) {
        $[method] = function (qname, url, data, callback, type) {

            if ($.isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }

            return $.ajaxq(qname, {
                type: method === "postq" ? "post" : "get",
                url: url,
                data: data,
                success: callback,
                dataType: type
            });
        };
    });

    var isQueueRunning = function (qname) {
        return queues.hasOwnProperty(qname);
    };

    var isAnyQueueRunning = function () {
        for (var i in queues) {
            if (isQueueRunning(i)) return true;
        }
        return false;
    };

    $.ajaxq.isRunning = function (qname) {
        if (qname) return isQueueRunning(qname);
        else return isAnyQueueRunning();
    };

    $.ajaxq.getActiveRequest = function (qname) {
        if (!qname) throw ("AjaxQ: queue name is required");

        return activeReqs[qname];
    };

    $.ajaxq.abort = function (qname) {
        if (!qname) throw ("AjaxQ: queue name is required");

        var current = $.ajaxq.getActiveRequest(qname);
        delete queues[qname];
        delete activeReqs[qname];
        if (current) current.abort();
    };

    $.ajaxq.clear = function (qname) {
        if (!qname) {
            for (var i in queues) {
                if (queues.hasOwnProperty(i)) {
                    queues[i] = [];
                }
            }
        } else {
            if (queues[qname]) {
                queues[qname] = [];
            }
        }
    };

    /***************** CUSTOM *****************/
    /*
     * Masked ajaxQ methods providing a default
     * queue to mimick the interface of normal
     * ajax calls.
     *
     */
    $.ajaxDefaultQ = function (opts) {
        return $.ajaxq("DefaultQueue", opts);
    };
    $.postDefaultQ = function (url, data, callback, type) {
        return $.postq("DefaultQueue", url, data, callback, type);
    };
    $.getDefaultQ = function (url, data, callback, type) {
        return $.getq("DefaultQueue", url, data, callback, type);
    };
    $.getJSONq = function (qname, url, data, success) {
        if ($.isFunction(data)) {
            success = data;
            data = undefined;
        }
        return $.ajaxq(qname, {
            type: "get",
            url: url,
            data: data,
            success: success,
            dataType: "json"
        });
    };
    $.getDefaultJSONQ = function (url, data, success) {
        return $.getJSONq("DefaultQueue", url, data, success);
    };
    /***************** /CUSTOM ****************/
})(jQuery);
